import { ValidateParamsExchange } from "../entities/IValidateParamsExchange";
export var ValidateParamsExchangeMapper = function (data) {
    var validateParamsForExchange = {
        email: ReturnIValidateParamsExportSubEntity(),
        mobile: ReturnIValidateParamsExportSubEntity(),
        address: ReturnIValidateParamsExportSubEntity(),
        incomeRange: ReturnIValidateParamsExportSubEntity(),
        panNo: ReturnIValidateParamsExportSubEntity(),
        name: ReturnIValidateParamsExportSubEntity(),
    };
    if (data && data.length > 0) {
        data.map(function (record) {
            switch (record.fieldName) {
                case ValidateParamsExchange.Email:
                    validateParamsForExchange.email.fieldValue = record.values;
                    validateParamsForExchange.email.highReason = record.reason != '' ? true : false;
                    validateParamsForExchange.email.isPassFail = record.passFail;
                    validateParamsForExchange.email.isValid = record.isvalidDays;
                    break;
                case ValidateParamsExchange.Mobile:
                    validateParamsForExchange.mobile.fieldValue = record.values;
                    validateParamsForExchange.mobile.highReason = record.reason != '' ? true : false;
                    validateParamsForExchange.mobile.isPassFail = record.passFail;
                    validateParamsForExchange.mobile.isValid = record.isvalidDays;
                    break;
                case ValidateParamsExchange.Address:
                    validateParamsForExchange.address.fieldValue = record.values;
                    validateParamsForExchange.address.highReason = record.reason != '' ? true : false;
                    validateParamsForExchange.address.isPassFail = record.passFail;
                    validateParamsForExchange.address.isValid = record.isvalidDays;
                    break;
                case ValidateParamsExchange.IncomeRange:
                    validateParamsForExchange.incomeRange.fieldValue = record.values;
                    validateParamsForExchange.incomeRange.highReason = record.reason != '' ? true : false;
                    validateParamsForExchange.incomeRange.isPassFail = record.passFail;
                    validateParamsForExchange.incomeRange.isValid = record.isvalidDays;
                    break;
                case ValidateParamsExchange.Name:
                    validateParamsForExchange.name.fieldValue = record.values;
                    validateParamsForExchange.name.highReason = record.reason != '' ? true : false;
                    validateParamsForExchange.name.isPassFail = record.passFail;
                    validateParamsForExchange.name.isValid = record.isvalidDays;
                    break;
                case ValidateParamsExchange.PANNO:
                    validateParamsForExchange.panNo.fieldValue = record.values;
                    validateParamsForExchange.panNo.highReason = record.reason != '' ? true : false;
                    validateParamsForExchange.panNo.isPassFail = record.passFail;
                    validateParamsForExchange.panNo.isValid = record.isvalidDays;
                    break;
            }
            // if(record.passFail =="F")
            // {
            //     validateParamsForExchange.passFail = true;
            // }
            // if(record.isvalidDays == "N")
            // {
            //     validateParamsForExchange.isValidDays = true;
            // }
        });
    }
    return validateParamsForExchange;
};
var ReturnIValidateParamsExportSubEntity = function () {
    var subObj = {
        fieldValue: "",
        isPassFail: "",
        highReason: null,
        isValid: ""
    };
    return subObj;
};
